export default [
    {
        path: '/invitation-page',
        meta: {
            title: '邀请'
        },
        component: () => import('@/views/invitationPage/home.vue'),
        children:[{
            path: 'register',
            name: 'invitationPageRegister',
            meta: {
                title: '邀请',
                activity:true
            },
            component: () => import('@/views/invitationPage/register.vue'),
        },{
            path: 'registerSuccess',
            name: 'invitationPageRegisterSuccess',
            meta: {
                title: '邀请',
                activity:true
            },
            component: () => import('@/views/invitationPage/registerSuccess.vue'),
        },{
            path: 'registerTwo',
            name: 'registerRegisterTwo',
            meta: {
                title: '邀请',
                activity:true
            },
            component: () => import('@/views/invitationPage/registerTwo.vue'),
        },{
            path: 'registerSuccessTwo',
            name: 'invitationPageRegisterSuccessTwo',
            meta: {
                title: '邀请',
                activity:true
            },
            component: () => import('@/views/invitationPage/registerSuccessTwo.vue'),
        },{
            path: 'registerThree',
            name: 'registerRegisterThree',
            meta: {
                title: '律师案源合作中心',
                activity:true
            },
            component: () => import('@/views/invitationPage/registerThree.vue'),
        },{
            path: 'registerSuccessThree',
            name: 'invitationPageRegisterSuccessThree',
            meta: {
                title: '律师案源合作中心',
                activity:true
            },
            component: () => import('@/views/invitationPage/registerSuccessThree.vue'),
        },
            {
                path: 'registerFour',
                name: 'registerRegisterFour',
                meta: {
                    title: '法临邀请您入驻',
                    activity:true
                },
                component: () => import('@/views/invitationPage/registerFour.vue'),
            },]
    }
]
